"use client";

import { c as _c } from "react/compiler-runtime";
import { IconXboxX } from "@tabler/icons-react";
import { AnimatePresence, motion } from "motion/react";
import { NotificationCard } from "@/components/notifications/notification-card";
import { NotificationEmptyState } from "@/components/notifications/notification-empty-state";
import { NotificationListSkeleton } from "@/components/notifications/notification-list-skeleton";
import type { NotificationData } from "@domainstack/types";
import { ScrollArea } from "@domainstack/ui/scroll-area";
import { Spinner } from "@domainstack/ui/spinner";
interface NotificationListProps {
  notifications: NotificationData[];
  isLoading: boolean;
  isError: boolean;
  view: "inbox" | "archive";
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  loadMoreRef?: React.RefObject<HTMLDivElement | null>;
  scrollAreaRef?: React.RefObject<HTMLDivElement | null>;
  onNotificationClick?: (notification: NotificationData) => void;
  onClosePopover?: () => void;
}
export function NotificationList(t0) {
  const $ = _c(27);
  const {
    notifications,
    isLoading,
    isError,
    view,
    hasNextPage,
    isFetchingNextPage,
    loadMoreRef,
    scrollAreaRef,
    onNotificationClick,
    onClosePopover
  } = t0;
  const t1 = !isLoading && !isError && notifications.length > 0 ? "divide-y" : undefined;
  let t2;
  if ($[0] !== isError || $[1] !== isLoading || $[2] !== notifications || $[3] !== onClosePopover || $[4] !== view) {
    t2 = isLoading ? <NotificationListSkeleton /> : isError ? <div role="alert" className="flex flex-col items-center justify-center gap-1.5 py-12 text-sm"><IconXboxX className="size-4" />Failed to load notifications</div> : notifications.length === 0 ? <NotificationEmptyState variant={view} onClosePopover={onClosePopover} /> : null;
    $[0] = isError;
    $[1] = isLoading;
    $[2] = notifications;
    $[3] = onClosePopover;
    $[4] = view;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isError || $[7] !== isLoading || $[8] !== notifications || $[9] !== onNotificationClick) {
    t3 = !isLoading && !isError && notifications.map(notification => <motion.div key={notification.id} layout="position" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: "easeInOut"
    }}><NotificationCard notification={notification} onClick={() => onNotificationClick?.(notification)} /></motion.div>);
    $[6] = isError;
    $[7] = isLoading;
    $[8] = notifications;
    $[9] = onNotificationClick;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <AnimatePresence mode="popLayout" initial={false}>{t3}</AnimatePresence>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== hasNextPage || $[14] !== isError || $[15] !== isFetchingNextPage || $[16] !== isLoading || $[17] !== loadMoreRef) {
    t5 = !isLoading && !isError && hasNextPage && <div ref={loadMoreRef} className="flex justify-center py-4">{isFetchingNextPage && <Spinner className="size-5 text-muted-foreground" />}</div>;
    $[13] = hasNextPage;
    $[14] = isError;
    $[15] = isFetchingNextPage;
    $[16] = isLoading;
    $[17] = loadMoreRef;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t4 || $[22] !== t5) {
    t6 = <div className={t1}>{t2}{t4}{t5}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== scrollAreaRef || $[25] !== t6) {
    t7 = <ScrollArea scrollRef={scrollAreaRef} className="min-h-0 flex-1 bg-popover/10">{t6}</ScrollArea>;
    $[24] = scrollAreaRef;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}